import { Observable, of } from 'rxjs';
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { environment } from './../../../environments/environment';
import {TokenAuthorization} from "../models/shared-model/token-authorization.model";
import {httpOptionsOauth} from "../config/config-app";

@Injectable()
export class SharedService {

    constructor(private location: Location,
                private httpClient: HttpClient) {}

    getSexo() {
        return [
            { value: 'FEMININO', description: 'Feminino'},
            { value: 'MASCULINO', description: 'Masculino'}
        ];
    }

    getEstadoCivil() {
        return [
            { value: 'SOLTEIRO', description: 'Solteiro'},
            { value: 'CASADO', description: 'Casado'},
            { value: 'SEPARADO', description: 'Separado'},
            { value: 'DIVORCIADO', description: 'Divorciado'},
            { value: 'VIUVO', description: 'Viúvo'},
            { value: 'UNIAO_ESTAVEL', description: 'União Estável'}
        ];
    }

    goBack(): void {
        this.location.back();
    }

    getEnderecoByViaCep(cep: string): Observable<any> {
        const urlBuscaEnderecoByCep = `${environment.viaCep.getEnderecoByCep}/${cep}/json`;
        console.log('Buscando endereço api rest viaCep:' + urlBuscaEnderecoByCep);
        return this.httpClient.get(urlBuscaEnderecoByCep)
            .pipe(catchError(this.handlerError<any>('getEnderecoByViaCep')));
    }

    private handlerError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
          // TODO: send the error to remote logging infrastructure
          console.error(error); // log to console instead
          // TODO: better job of transforming error for user consumption
          console.log(`${operation} failed: ${error.message}`);
          // Let the app keep running by returning an empty result.
          return of(result as T);
        };
    }

    getTokenSGI(): Observable<TokenAuthorization> {
        let body = `grant_type=client_credentials&client_id=${environment.security.client_id}&client_secret=${environment.security.client_secret}`;
        return this.httpClient.post<TokenAuthorization>(environment.security.token_url, body, httpOptionsOauth);
    }

}
